import DeviceInfo from 'react-native-device-info'

interface AndroidDiagnosticInfo {
  apiLevel: number
  deviceID: string
  brand: string
  usedMemory: number
  totalMemory: number
}

export const getAndroidDiagnosticInfo =
  async (): Promise<AndroidDiagnosticInfo> => {
    return {
      apiLevel: await DeviceInfo.getApiLevel(),
      deviceID: DeviceInfo.getDeviceId(),
      brand: DeviceInfo.getBrand(),
      usedMemory: await DeviceInfo.getUsedMemory(),
      totalMemory: await DeviceInfo.getTotalMemory(),
    }
  }
